export const dateToString = (date: Date, locale: string) => {
	return date.toLocaleDateString(locale, { day: "2-digit", month: "long" });
};

export const formatTime = (time: string, locale: string) => {
	const date = new Date();
	const [hour, minute, period] = time.split(/[:\s]/);
	date.setHours(parseInt(hour) + (period === "PM" ? 12 : 0));
	date.setMinutes(parseInt(minute));

	return date.toLocaleTimeString(locale, {
		hour: "2-digit",
		minute: "2-digit",
	});
};
